import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45a19566"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-space-between align-center mb-10" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "text-h6"
}
const _hoisted_5 = { class: "d-flex align-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "text-h6"
}
const _hoisted_8 = { class: "text-bold align-center text-gray-800 ms-3" }
const _hoisted_9 = { class: "text-bold align-center text-md text-gray-950" }
const _hoisted_10 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_11 = { class: "grey text-xs no-wrap-text" }
const _hoisted_12 = { class: "text-bold text-xs text-gray-950 no-wrap-text" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-bottom":"1.6%","color":"transparent"} }, " Ver detalhes ", -1))
const _hoisted_14 = { class: "mt-4" }
const _hoisted_15 = { class: "text-bold mb-6" }
const _hoisted_16 = { class: "text-bold" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-bold mb-6" }, null, -1))

import { toRefs, watch, ref, computed } from 'vue';
import { AtomBadge, AtomButton, AtomInput, AtomInputBrands, AtomProgressBar, AtomTableModal, AtomToogleButton, AtomSelect } from '@/components/atoms';
import { MoleculeModalGoal, MoleculeTableSmall, MoleculeTableSmallModal2, MoleculeModalAlert, MoleculeModalGoalsGroup } from '@/components/molecules'
import { IBrandsDetailMeta, IDataCommission, IHeadersTable, IOrientationGoal, ISeasonality, IToggleButon, IOptionsSelect, PageData, Source } from '@/types';
import { Brand, Goal } from '@/core/model';
import { format } from 'date-fns';
import { getPaginate as getBrands } from '@/core/service/BrandsService'
import { getPaginate as getCostCenters } from '@/core/service/CostCentersService'
import { update, updateBrands, updateCostCenters } from '@/core/service/GoalsService'
import { Preloader, Authentication } from '@/store';
import Swal from 'sweetalert2';
import { formatCurrency, formatPercentage, formatTriggerItemPercentageLabel } from '@/utils/formatNumber';
import { formatRoleName } from '@/utils/format';
import { getLanguage } from "@/utils/locale";
import { messages } from "@/utils/i18n";
import { CostCenter } from '@/core/model/CostCenter';
interface IProps {
  name: string;
  row: IDataCommission[],
  email: string;
  iconBrand: string;
  badgeText: string
  badgeColor: string
  badgeTextColor: string
  isProgress?: boolean
  progress?: number
  orientation: IOrientationGoal[]
  goal: Goal
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeGoal',
  props: {
    name: {},
    row: {},
    email: {},
    iconBrand: {},
    badgeText: {},
    badgeColor: {},
    badgeTextColor: {},
    isProgress: { type: Boolean },
    progress: {},
    orientation: {},
    goal: {}
  },
  emits: ['handleLoad'],
  setup(__props: any, { emit: __emit }) {

let locale: string = messages[getLanguage()]['message'];

const showGoalGroup = ref<boolean>(false);
function showModalGoalGroup() {
  showGoalGroup.value = true;
}

const emit = __emit;
const actives = ref<IToggleButon[]>([
  { text: locale['goals_details']['active'], value: '1' },
  { text: locale['goals_details']['inactive'], value: '0' },
])

const showModal = ref<boolean>(false);

const brands = ref<Brand[]>([]);
const brandsComputed = computed(() => {
  const goalBrandIds = goal.value.brands?.flatMap(brand => brand.id);
  return brands.value.filter(f => { return f.name != "- Nenhum fabricante -" }).filter((b) => { return !goalBrandIds?.includes(b.id); })
    .map(f => {
      return { text: f.name, value: f.id } as IOptionsSelect;
    });
});
const brands_to_add = ref<number[]>([]);
const can_edit_brands = ref<boolean>(false);
const isSearching = ref<boolean>(false);
const filteredData = ref<IOptionsSelect[]>([]);

function loadBrands() {
  getBrands(undefined, undefined, undefined, true).then((resp) => {
    brands.value = resp.data;
  });
}

const costCenters = ref<CostCenter[]>([]);
const costCentersComputed = computed(() => {
  const goalCostCentersIds = goal.value.costCenters?.flatMap(cost_center => cost_center.id);
  return costCenters.value.filter((b) => { return !goalCostCentersIds?.includes(b.id); })
    .map(f => {
      return { text: `${f.sap_cost_center_code} - ${f.name}`, value: f.id } as IOptionsSelect;
    });
});
const cost_centers_to_add = ref<number[]>([]);
const can_edit_cost_centers = ref<boolean>(false);
const isSearchingCostCenter = ref<boolean>(false);
const filteredCostCenterData = ref<IOptionsSelect[]>([]);

function loadCostCenters() {
  getCostCenters(undefined, undefined, undefined, true).then((resp) => {
    costCenters.value = resp.data;
  });
}

const filteredSearch = (value) => {
  if (!isSearching.value && value.length >= 3) {
    isSearching.value = true;
    const goalBrandIds = goal.value.brands?.flatMap(brand => brand.id);
    setTimeout(() => {
      filteredData.value = brands.value.filter(f => { return f.name != "- Nenhum fabricante -" }).filter((b) => { return !goalBrandIds?.includes(b.id); })
        .map(f => {
          return { text: f.name, value: f.id } as IOptionsSelect;
        });
    }, 3000);

    return;
  }

  filteredData.value = [];
  isSearching.value = false;
}

const filteredCostCenterSearch = (value) => {
  if (!isSearchingCostCenter.value && value.length >= 3) {
    isSearchingCostCenter.value = true;
    const goalCostCentersIds = goal.value.costCenters?.flatMap(cost_center => cost_center.id);
    setTimeout(() => {
      filteredCostCenterData.value = costCenters.value.filter((b) => { return !goalCostCentersIds?.includes(b.id); })
        .map(f => {
          return { text: `${f.sap_cost_center_code} - ${f.name}`, value: f.id } as IOptionsSelect;
        });
    }, 3000);

    return;
  }

  filteredCostCenterData.value = [];
  isSearchingCostCenter.value = false;
}

function editBrand() {
  // Limpa os dados
  can_edit_brands.value = false;
  brands_to_add.value = [];
  brands.value = [];

  can_edit_brands.value = true;
}

function editCostCenter() {
  // Limpa os dados
  can_edit_cost_centers.value = false;
  cost_centers_to_add.value = [];
  costCenters.value = [];

  can_edit_cost_centers.value = true;
}

function handleEditBrand() {
  if (brands_to_add.value.length > 0) {
    Preloader.actions.ActionSetPreloader(true);
    updateBrands(goal.value.id as number, brands_to_add.value).then(f => {
      Swal.fire({
        text: locale['goals_create']['goal_updated'],
        title: locale['common']['success'],
        icon: 'success'
      });
      // Atualiza a lista de brands no goal para exibir no modal
      brands.value = brands.value.filter((b) => { return brands_to_add.value.includes(b.id!) });
      goal.value.brands?.push(...brands.value);
    }).finally(() => {
      // Limpa os dados
      can_edit_brands.value = false;
      brands_to_add.value = [];
      brands.value = [];

      Preloader.actions.ActionSetPreloader(false);
    });
  }
  else {
    // Limpa os dados
    can_edit_brands.value = false;
    brands_to_add.value = [];
    brands.value = [];
  }
}

function handleEditCostCenter() {
  if (cost_centers_to_add.value.length > 0) {
    console.log("handle", cost_centers_to_add.value);
    Preloader.actions.ActionSetPreloader(true);
    updateCostCenters(goal.value.id as number, cost_centers_to_add.value).then(f => {
      Swal.fire({
        text: locale['goals_create']['goal_updated'],
        title: locale['common']['success'],
        icon: 'success'
      });
      // Atualiza a lista de cost_center no goal para exibir no modal
      costCenters.value = costCenters.value.filter((b) => { return cost_centers_to_add.value.includes(b.id!) });
      goal.value.costCenters?.push(...costCenters.value);
    }).finally(() => {
      // Limpa os dados
      can_edit_cost_centers.value = false;
      cost_centers_to_add.value = [];
      costCenters.value = [];

      Preloader.actions.ActionSetPreloader(false);
    });
  }
  else {
    // Limpa os dados
    can_edit_cost_centers.value = false;
    cost_centers_to_add.value = [];
    costCenters.value = [];
  }
}

const props = __props
const onClick = ref<boolean>(false);

const showDetails = ref<boolean>(false)
const iconHasHttp = computed(() => {
  return (props.iconBrand ?? '').includes('http')
})

const goalName = computed(() => {
  let goal_name = goal.value.name;
  if (process.env.VUE_APP_ENVIRONMENT == 'development' || process.env.VUE_APP_ENVIRONMENT == 'stage') {
    let aux_goal_name = goal.value.name?.split(' - ');
    goal_name = process.env.VUE_APP_DEFAULT_GOAL_NAME + (aux_goal_name ? ' - ' + aux_goal_name[1] : '');
  }

  return goal_name;
});

const userName = computed(() => {
  return (process.env.VUE_APP_ENVIRONMENT == 'development' || process.env.VUE_APP_ENVIRONMENT == 'stage' ? process.env.VUE_APP_DEFAULT_USER_NAME : goal.value.user?.name);
});

const sellerName = computed(() => {
  return ((process.env.VUE_APP_ENVIRONMENT == 'development' || process.env.VUE_APP_ENVIRONMENT == 'stage') && goal.value.seller?.name ? process.env.VUE_APP_DEFAULT_USER_NAME : goal.value.seller?.name ?? '');
});


const goalGroup = computed(() => {
  return goal.value.goal_group;
});

const brandItems = computed(() => {
  return goal.value.brands?.map(f => { return { image: f.image_url ? `${process.env.VUE_APP_API_URL.replace('/api', '')}${f.image_url}` : (f.name ?? '').split(' ').map(x => x[0]).join(''), name: f.name } as IBrandsDetailMeta })
});

const resaleItems = computed(() => {
  return goal.value.resales?.map(f => { return { image: (f.sap_card_name ?? '').split(' ').map(x => x[0]).join(''), name: f.sap_card_name } as IBrandsDetailMeta })
});

const depositItems = computed(() => {
  return goal.value.warehouses?.map(f => { return { image: (f.name ?? '').split(' ').map(x => x[0]).join(''), name: f.name } as IBrandsDetailMeta })
});

const costCenterItems = computed(() => {
  return goal.value.costCenters?.map(f => { return { image: (f.name ?? '').split(' ').map(x => x[0]).join(''), name: `${f.sap_cost_center_code} - ${f.name}` } as IBrandsDetailMeta })
});

const seasonItens = computed(() => {
  const data: ISeasonality[] = []
  if (goal.value.season) {
    Object.keys(goal.value.season).map(x => {
      if (!goal.value.season?.is_quarter) {
        if (x == 'jan' || x == 'feb' || x == 'mar' || x == 'apr' || x == 'may' || x == 'jun' ||
          x == 'jul' || x == 'aug' || x == 'sep' || x == 'oct' || x == 'nov' || x == 'dec') {
          data.push({
            month:
              x == 'jan' ? locale['goals_details']['jan']
                : x == 'feb' ? locale['goals_details']['feb']
                  : x == 'mar' ? locale['goals_details']['mar']
                    : x == 'apr' ? locale['goals_details']['apr']
                      : x == 'may' ? locale['goals_details']['may']
                        : x == 'jun' ? locale['goals_details']['jun']
                          : x == 'jul' ? locale['goals_details']['jul']
                            : x == 'aug' ? locale['goals_details']['aug']
                              : x == 'sep' ? locale['goals_details']['sep']
                                : x == 'oct' ? locale['goals_details']['oct']
                                  : x == 'nov' ? locale['goals_details']['nov']
                                    : x == 'dec' ? locale['goals_details']['dec'] : '',
            percentage: formatPercentage(goal.value.season[x]),
            value: formatCurrency(Number(goal.value.value) * (Number(goal.value.season[x]) / 100))
          });
        }
      } else {
        if (x == 'quarter_1' || x == 'quarter_2' || x == 'quarter_3' || x == 'quarter_4') {
          data.push({
            month:
              x == 'quarter_1' ? locale['seasoning']['first_quarter']
                : x == 'quarter_2' ? locale['seasoning']['second_quarter']
                  : x == 'quarter_3' ? locale['seasoning']['third_quarter']
                    : x == 'quarter_4' ? locale['seasoning']['fourth_quarter'] : '',
            percentage: formatPercentage(goal.value.season[x]),
            value: formatCurrency(Number(goal.value.value) * (Number(goal.value.season[x]) / 100))
          });
        }
      }
    });
  }
  else {
    for (let i = 0; i < 12; i++) {
      data.push({
        month:
          i == 0 ? locale['goals_details']['jan']
            : i == 1 ? locale['goals_details']['feb']
              : i == 2 ? locale['goals_details']['mar']
                : i == 3 ? locale['goals_details']['apr']
                  : i == 4 ? locale['goals_details']['may']
                    : i == 5 ? locale['goals_details']['jun']
                      : i == 6 ? locale['goals_details']['jul']
                        : i == 7 ? locale['goals_details']['aug']
                          : i == 8 ? locale['goals_details']['sep']
                            : i == 9 ? locale['goals_details']['oct']
                              : i == 10 ? locale['goals_details']['nov']
                                : i == 11 ? locale['goals_details']['dec'] : '',
        percentage: formatPercentage(0),
        value: formatCurrency(0)
      });
    }
  }
  return data
})

const badgeColor = computed(() => {
  return props.goal.performants_goals?.is_required ? Number(props.progress) >= Number(100) ? '#E6B300' : '#FC4969' : Number(props.progress) >= Number(100) ? '#17CF97' : '#801434';
});

const hearderGatilho = computed(() => {
  return (goal.value.triggers_goals ?? []).sort((a, b) => (a?.trigger_item?.order ?? 0) - (b?.trigger_item?.order ?? 0)).map(f => {

    return `${formatTriggerItemPercentageLabel(Number(f.trigger_item?.start_value ?? 0), Number(f.trigger_item?.end_value ?? 0))}`;
  })
})

const itemsGatilho = computed(() => {
  return (goal.value.triggers_goals ?? []).sort((a, b) => (a?.trigger_item?.order ?? 0) - (b?.trigger_item?.order ?? 0)).map(f => {
    return formatPercentage(f.value);
  })
})

const hearders = ref<IHeadersTable[]>([
  { label: locale['common']['margin'], field: 'margin' },
  {
    label: locale['common']['period'], field: 'period',
    extra: {
      composite: ['start_date', 'end_date'],
      join: locale['common']['date_connection']
    }
  },
  { label: locale['common']['required'], field: 'isRequired', type: 'checkbox' },
  { label: locale['triggers']['bonus'], field: 'bonus', type: 'text' },
]);

const items = computed(() => {
  return [{
    margin: formatCurrency(Number(goal.value.value)),
    start_date: format(new Date(`${goal.value.start_date}T00:00:00`), 'dd/MM/yyyy'),
    end_date: format(new Date(`${goal.value.end_date}T00:00:00`), 'dd/MM/yyyy'),
    isRequired: goal.value.performants_goals?.is_required == 1,
    cross: goal.value.is_cross == 1,
    transfer: goal.value.is_transfer == 1,
    bonus: goal.value.is_bonus_goal ? `${formatPercentage(goal.value?.bonus_reward ?? 0)}` : undefined
  }]
})

const { goal } = toRefs(props)

function handleFinishGoal(event) {

  Preloader.actions.ActionSetPreloader(true);
  goal.value.reason = event;
  update(goal.value.id as number, goal.value).then(f => {

    Swal.fire({
      text: locale['goals_delete']['goal_closed'],
      title: locale['common']['success'],
      icon: 'success'
    });
    emit('handleLoad');
    showDetails.value = false;
    window.location.reload();
  }).finally(() => {
    Preloader.actions.ActionSetPreloader(true);
  })
}

watch(
  () => showDetails.value,
  () => {
    if (!showDetails.value) {
      // Limpa os dados
      can_edit_brands.value = false;
      brands_to_add.value = [];
      brands.value = [];
      can_edit_cost_centers.value = false;
      cost_centers_to_add.value = [];
      costCenters.value = [];
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_textarea = _resolveComponent("v-textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "card-meta cursor-pointer",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (showDetails.value = true))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_avatar, {
            color: "grey",
            size: "30",
            rounded: "0",
            class: "icon-datalogic me-3 mt-1",
            style: {"border-radius":"15% !important"}
          }, {
            default: _withCtx(() => [
              (iconHasHttp.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    style: {"width":"100%","height":"100%"},
                    src: `${props.iconBrand ?? ''}`,
                    crossorigin: "anonymous"
                  }, null, 8, _hoisted_3))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString((props.iconBrand ?? 'T').toUpperCase()), 1))
            ]),
            _: 1
          }),
          _createVNode(_component_v_menu, {
            "open-on-hover": "",
            class: "molecule-menu"
          }, {
            activator: _withCtx(({ props: activatorProps }) => [
              (props.orientation.length)
                ? (_openBlock(), _createElementBlock("span", _mergeProps({
                    key: 0,
                    type: "button",
                    class: "elipse-red mb-8 mr-1"
                  }, activatorProps, {
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                  }), "+" + _toDisplayString(props.orientation.length), 17))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, {
                class: "menu-rounded pa-8",
                style: {"min-width":"319px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.orientation, (item) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (onClick.value = false)),
                      class: "border-bot py-6 px-0",
                      key: item.name
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, { title: "Option 1" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_v_avatar, {
                                color: "grey",
                                size: "30",
                                style: {"border-radius":"15% !important"},
                                rounded: "0",
                                class: "icon-datalogic"
                              }, {
                                default: _withCtx(() => [
                                  (item.url.includes('http'))
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        style: {"height":"100%","width":"100%"},
                                        src: `${item.url}`,
                                        crossorigin: ""
                                      }, null, 8, _hoisted_6))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.url.toUpperCase()), 1))
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("p", _hoisted_8, _toDisplayString(item.name), 1)
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(props.name), 1),
            (_unref(Authentication).getters.isMasterOrAdmin.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(props.email), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        (props.isProgress)
          ? (_openBlock(), _createBlock(_unref(AtomProgressBar), {
              key: 0,
              progressColor: `${badgeColor.value}`,
              modelValue: props.progress,
              hasPercent: false,
              hasTitle: false
            }, null, 8, ["progressColor", "modelValue"]))
          : _createCommentVNode("", true),
        (!props.isProgress)
          ? (_openBlock(), _createBlock(_unref(AtomBadge), {
              key: 1,
              text: props.badgeText,
              color: props.badgeTextColor,
              bgColor: props.badgeColor,
              class: "white-space-nowrap"
            }, null, 8, ["text", "color", "bgColor"]))
          : _createCommentVNode("", true),
        (!props.isProgress && _unref(goal).active == 0)
          ? (_openBlock(), _createBlock(_unref(AtomBadge), {
              key: 2,
              text: _ctx.$t('message.goals_details.inactive_goal'),
              color: '#546375',
              bgColor: '#EAECF6',
              class: "white-space-nowrap w-100 mt-2"
            }, null, 8, ["text"]))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row, (item) => {
        return (_openBlock(), _createBlock(_component_v_row, {
          class: "mb-3",
          key: item.text
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "5" }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_11, _toDisplayString(item.text), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_v_col, {
              cols: "7",
              class: "d-flex justify-end"
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_12, _toDisplayString(item.value), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_v_divider, { class: "mb-1" })
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    (showDetails.value)
      ? (_openBlock(), _createBlock(_unref(MoleculeModalGoal), {
          key: 0,
          width: "100%",
          onHandleCancelGoal: _cache[14] || (_cache[14] = ($event: any) => {showDetails.value = false;}),
          title: _ctx.$t('message.goals_details.details'),
          show: showDetails.value,
          "btn-close-text": "Cancelar"
        }, {
          body: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6",
                  md: "3",
                  lg: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(AtomInput), {
                      label: _ctx.$t('message.common.title'),
                      placeholder: "Campanha Ásia",
                      disabled: "",
                      modelValue: goalName.value
                    }, null, 8, ["label", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6",
                  md: "3",
                  lg: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(AtomInput), {
                      label: _ctx.$t('message.goals_details.employee_name'),
                      placeholder: "Jorge Henrique",
                      disabled: "",
                      modelValue: userName.value
                    }, null, 8, ["label", "modelValue"])
                  ]),
                  _: 1
                }),
                (_unref(Authentication).getters.isMasterOrAdmin.value)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "12",
                      sm: "6",
                      md: "3",
                      lg: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInput), {
                          label: _ctx.$t('message.common.role'),
                          placeholder: _ctx.$t('message.goals_create.employee'),
                          disabled: "",
                          modelValue: _unref(formatRoleName)(_unref(goal).role?.name)
                        }, null, 8, ["label", "placeholder", "modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(goal).role?.id === 2)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 1,
                      cols: "12",
                      sm: "6",
                      md: "3",
                      lg: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInput), {
                          label: _ctx.$t('message.common.seller'),
                          placeholder: _ctx.$t('message.common.sellerName'),
                          disabled: "",
                          modelValue: sellerName.value
                        }, null, 8, ["label", "placeholder", "modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6",
                  md: "3",
                  lg: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(AtomInput), {
                      label: _ctx.$t('message.common.goal_orientation'),
                      placeholder: _ctx.$t('message.common.brand'),
                      disabled: "",
                      modelValue: _unref(goal).goal_orientation == 'brand' ? _ctx.$t('message.common.brand') : _unref(goal).goal_orientation == 'resale' ? _ctx.$t('message.goals_create.resale') : _unref(goal).goal_orientation == 'cost_center' ? _ctx.$t('message.common.cost_center') : _ctx.$t('message.common.warehouse')
                    }, null, 8, ["label", "placeholder", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  sm: "6",
                  md: "3",
                  lg: "3"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("label", {
                      class: _normalizeClass(_unref(goal).role?.id === 2 ? 'mt-4' : 'mb-2')
                    }, _toDisplayString(_ctx.$t('message.common.status')), 3),
                    _createVNode(_unref(AtomToogleButton), {
                      buttons: actives.value,
                      select: String(_unref(goal).active),
                      disabled: ""
                    }, null, 8, ["buttons", "select"])
                  ]),
                  _: 1
                }),
                (goalGroup.value)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 2,
                      cols: "12",
                      sm: "6",
                      md: "3",
                      lg: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInput), {
                          label: _ctx.$t('message.contributor_summary.goal_group'),
                          disabled: "",
                          modelValue: goalGroup.value?.name
                        }, null, 8, ["label", "modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (goalGroup.value)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 3,
                      cols: "12",
                      sm: "3",
                      md: "3",
                      lg: "3"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13,
                        _createVNode(_unref(AtomButton), {
                          outlined: "",
                          background: "grey-lighten-3",
                          "hover-color": "var(--color-gray-03)",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (showModalGoalGroup()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Ver detalhes do grupo ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(MoleculeModalGoalsGroup), {
                          showModal: showGoalGroup.value,
                          onHandleCancel: _cache[4] || (_cache[4] = ($event: any) => {showGoalGroup.value = false;}),
                          group: goalGroup.value
                        }, null, 8, ["showModal", "group"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_unref(goal).active)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 4,
                      cols: "12",
                      sm: "6",
                      md: "6",
                      lg: "6"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('message.goals_details.reason')), 1),
                        _createVNode(_component_v_textarea, {
                          modelValue: _unref(goal).reason,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(goal).reason) = $event)),
                          disabled: "",
                          rows: 1
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (brandItems.value?.length && _unref(Authentication).getters.isMaster.value && !_unref(goal).is_clearance_sale)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "11",
                      class: "my-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInputBrands), {
                          label: _ctx.$t('message.common.brands'),
                          items: brandItems.value ?? [],
                          type: 'brand'
                        }, null, 8, ["label", "items"])
                      ]),
                      _: 1
                    }),
                    (brandItems.value?.length && _unref(goal).active && _unref(Authentication).getters.isMaster.value && !_unref(goal).is_clearance_sale)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "1",
                          class: "my-3 d-flex align-end"
                        }, {
                          default: _withCtx(() => [
                            (!can_edit_brands.value)
                              ? (_openBlock(), _createBlock(_unref(AtomButton), {
                                  key: 0,
                                  background: "tertiary",
                                  "no-hover": "",
                                  outlined: "",
                                  style: {"height":"65%"},
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (editBrand()))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('message.goals_details.change_goal')), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (can_edit_brands.value)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                  default: _withCtx(() => [
                    (!_unref(goal).is_clearance_sale)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "11"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(AtomSelect), {
                              label: _ctx.$t('message.goals_details.brands_add'),
                              placeholder: _ctx.$t('message.goals_details.choose_brands'),
                              options: filteredData.value.length ? filteredData.value : brandsComputed.value,
                              multiple: "",
                              enableLoad: filteredData.value.length ? false : true,
                              onLoad: loadBrands,
                              modelValue: brands_to_add.value,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((brands_to_add).value = $event)),
                              "handle-search": filteredSearch
                            }, null, 8, ["label", "placeholder", "options", "enableLoad", "modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (brandItems.value?.length && _unref(goal).active && _unref(Authentication).getters.isMaster.value && !_unref(goal).is_clearance_sale)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 1,
                          cols: "1",
                          class: "d-flex align-end"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(AtomButton), {
                              background: "quaternary",
                              outlined: "",
                              "no-hover": "",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (handleEditBrand()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('message.goals_details.save')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (brandItems.value?.length && !_unref(Authentication).getters.isMaster.value)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "my-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInputBrands), {
                          label: _ctx.$t('message.common.brands'),
                          items: brandItems.value ?? [],
                          type: 'brand'
                        }, null, 8, ["label", "items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (costCenterItems.value?.length && _unref(Authentication).getters.isMaster.value)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 3 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "11",
                      class: "my-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInputBrands), {
                          label: _ctx.$t('message.goals_details.cost_centers'),
                          items: costCenterItems.value ?? [],
                          type: 'cost_center'
                        }, null, 8, ["label", "items"])
                      ]),
                      _: 1
                    }),
                    (costCenterItems.value?.length && _unref(goal).active && _unref(Authentication).getters.isMaster.value)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "1",
                          class: "my-3 d-flex align-end"
                        }, {
                          default: _withCtx(() => [
                            (!can_edit_cost_centers.value)
                              ? (_openBlock(), _createBlock(_unref(AtomButton), {
                                  key: 0,
                                  background: "tertiary",
                                  "no-hover": "",
                                  outlined: "",
                                  style: {"height":"65%"},
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (editCostCenter()))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('message.goals_details.change_goal')), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (can_edit_cost_centers.value)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "11" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomSelect), {
                          label: _ctx.$t('message.goals_details.cost_center_to_add'),
                          placeholder: _ctx.$t('message.goals_details.choose_cost_centers_to_add'),
                          options: filteredCostCenterData.value.length ? filteredCostCenterData.value : costCentersComputed.value,
                          multiple: "",
                          enableLoad: filteredCostCenterData.value.length ? false : true,
                          onLoad: loadCostCenters,
                          modelValue: cost_centers_to_add.value,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((cost_centers_to_add).value = $event)),
                          "handle-search": filteredCostCenterSearch
                        }, null, 8, ["label", "placeholder", "options", "enableLoad", "modelValue"])
                      ]),
                      _: 1
                    }),
                    (costCenterItems.value?.length && _unref(goal).active && _unref(Authentication).getters.isMaster.value)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "1",
                          class: "d-flex align-end"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(AtomButton), {
                              background: "quaternary",
                              outlined: "",
                              "no-hover": "",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (handleEditCostCenter()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('message.goals_details.save')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (costCenterItems.value?.length && !_unref(Authentication).getters.isMaster.value)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 5 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "my-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInputBrands), {
                          label: _ctx.$t('message.common.brands'),
                          items: costCenterItems.value ?? [],
                          type: 'brand'
                        }, null, 8, ["label", "items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                (resaleItems.value?.length)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "12",
                      class: "my-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInputBrands), {
                          label: _ctx.$t('message.common.resales'),
                          items: resaleItems.value ?? [],
                          type: 'reseale'
                        }, null, 8, ["label", "items"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (depositItems.value?.length)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 1,
                      cols: "12",
                      class: "my-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInputBrands), {
                          label: _ctx.$t('message.warehouse_create.warehouses'),
                          items: depositItems.value ?? [],
                          type: 'warehouse'
                        }, null, 8, ["label", "items"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('message.common.seasonality')), 1),
                    _createVNode(_unref(AtomTableModal), {
                      items: seasonItens.value,
                      style: {"margin-left":"0px","margin-right":"0px"}
                    }, null, 8, ["items"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "justify-space-between" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "5",
                  class: "mt-4"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('message.common.triggers')), 1),
                    _createVNode(_unref(MoleculeTableSmall), {
                      headers: hearderGatilho.value,
                      items: itemsGatilho.value
                    }, null, 8, ["headers", "items"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "5",
                  class: "mt-3"
                }, {
                  default: _withCtx(() => [
                    _hoisted_17,
                    _createVNode(_unref(MoleculeTableSmallModal2), {
                      headers: hearders.value,
                      items: items.value
                    }, null, 8, ["headers", "items"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "d-flex justify-end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(AtomButton), {
                      background: "transparent",
                      outlined: "",
                      "no-hover": "",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => {showDetails.value = false;})
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('message.common.back')), 1)
                      ]),
                      _: 1
                    }),
                    (_unref(goal).active && _unref(Authentication).getters.isMaster.value)
                      ? (_openBlock(), _createBlock(_unref(AtomButton), {
                          key: 0,
                          class: "ms-sm-4 btn-confirm",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => {showModal.value = true;})
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('message.goals_details.close_goal')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title", "show"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(MoleculeModalAlert), {
      "show-alert-confirm": showModal.value,
      icon: 'GoalFinishIcon',
      text: _ctx.$t('message.goals_delete.close_goal'),
      onCancel: _cache[15] || (_cache[15] = ($event: any) => {showModal.value = false;}),
      onConfirm: handleFinishGoal,
      "is-text": true,
      label: _ctx.$t('message.goals_delete.reason')
    }, null, 8, ["show-alert-confirm", "text", "label"])
  ], 64))
}
}

})